"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportStoryStoryViewWeb = exports.reportStorySnapViewWeb = exports.StoryEntryEvent = void 0;
const constants_1 = require("../constants");
const web_sc_cookies_1 = require("@snapchat/web-sc-cookies");
const web_env_1 = require("@snapchat/web-env");
const web_blizzard_reporting_1 = require("@snapchat/web-blizzard-reporting");
const blizzard_1 = require("@snapchat/blizzard");
function translateStoryType(storyType) {
    switch (storyType) {
        case constants_1.WWWStoryType.DYNAMIC:
            return "DYNAMIC";
        case constants_1.WWWStoryType.PUBLIC_USER:
        case constants_1.Type.PublicUserStory:
            return "USER_PUBLIC";
        case constants_1.WWWStoryType.PUBLISHER:
        case constants_1.Type.Publisher:
            return "PUBLISHER";
        case constants_1.WWWStoryType.SPOTLIGHT:
            return "SPOTLIGHT";
        case constants_1.Type.Show:
            return "SHOW";
    }
    return null;
}
var StoryEntryEvent;
(function (StoryEntryEvent) {
    StoryEntryEvent["AUTO_ADVANCE"] = "AUTO_ADVANCE";
    StoryEntryEvent["REPLAY"] = "WEB_REPLAY";
    StoryEntryEvent["TAP"] = "TAP";
})(StoryEntryEvent = exports.StoryEntryEvent || (exports.StoryEntryEvent = {}));
const WEB_VIEW_SOURCE = "WEB";
function logSnapViewWeb(exitEvent, fullView, snapIndexCount, snapIndexPos, storyId, storySnapId, storyType, timeViewed) {
    if ((0, web_env_1.isRunningOnServer)()) {
        // Don't report metrics if we are running on server
        console.warn("skipping metric reporting on server side");
        return;
    }
    const storyTypeSpecific = translateStoryType(storyType);
    if (!storyTypeSpecific) {
        console.error(`${storyType} is not currently supported.`);
    }
    const sessionId = (0, web_sc_cookies_1.tryGetActiveSession)();
    const url = (0, web_env_1.getWindow)()?.location.href || "";
    (0, blizzard_1.logEvent)({
        event_name: web_blizzard_reporting_1.BlizzardEvent.STORY_SNAP_VIEW_WEB,
        exit_event: exitEvent,
        full_view: fullView,
        session_id: sessionId,
        snap_index_count: snapIndexCount,
        snap_index_pos: snapIndexPos,
        story_id: storyId,
        story_snap_id: storySnapId,
        story_type_specific: storyTypeSpecific ?? undefined,
        time_viewed: timeViewed,
        view_source: WEB_VIEW_SOURCE,
        story_view_url: url,
    });
}
function logStoryViewWeb(exitEvent, entryEvent, numSnapsUniqueViewed, numSnapsViewed, snapCount, storyId, storyType, timeViewed) {
    if ((0, web_env_1.isRunningOnServer)()) {
        // Don't report metrics if we are running on server
        console.warn("skipping metric reporting on server side");
        return;
    }
    const storyTypeSpecific = translateStoryType(storyType);
    if (!storyTypeSpecific) {
        console.error(`${storyType} is not currently supported.`);
        return;
    }
    const sessionId = (0, web_sc_cookies_1.tryGetActiveSession)();
    const url = (0, web_env_1.getWindow)()?.location.href || "";
    (0, blizzard_1.logEvent)({
        event_name: web_blizzard_reporting_1.BlizzardEvent.STORY_STORY_VIEW_WEB,
        exit_event: exitEvent,
        entry_event: entryEvent,
        full_view: numSnapsUniqueViewed === numSnapsViewed,
        num_snaps_unique_viewed: numSnapsUniqueViewed,
        num_snaps_viewed: numSnapsViewed,
        session_id: sessionId,
        snap_count: snapCount,
        story_id: storyId,
        story_type_specific: storyTypeSpecific,
        time_viewed: timeViewed,
        view_source: WEB_VIEW_SOURCE,
        story_view_url: url,
    });
}
function reportStorySnapViewWeb(analyticsSnapView, story, currentSnap, exitEvent) {
    if (!analyticsSnapView.endTime) {
        // Nothing to report
        return;
    }
    logSnapViewWeb(exitEvent, analyticsSnapView.fullView || false, story.snaps?.length || 0, currentSnap, story.id || "", story.snaps?.[currentSnap]?.id || "", story.type.toString() || "", (analyticsSnapView.endTime - analyticsSnapView.startTime) / 1000 // time viewed in seconds
    );
}
exports.reportStorySnapViewWeb = reportStorySnapViewWeb;
function reportStoryStoryViewWeb(analyticsSnapViewsByIndex, story, exitEvent) {
    // Always log sum of all snap views for the story
    let snapFullViewCount = 0;
    let snapUniqueViewCount = 0;
    let storyViewDuration = 0;
    const snapIndexes = Object.keys(analyticsSnapViewsByIndex).map(Number);
    if (snapIndexes.length === 0) {
        return;
    }
    for (const index of snapIndexes) {
        const snapIndex = snapIndexes[index];
        let isSnapFullViewed = false;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        for (const analyticsSnapViewRecord of analyticsSnapViewsByIndex[snapIndex] || []) {
            if (analyticsSnapViewRecord.endTime && analyticsSnapViewRecord.startTime) {
                storyViewDuration += analyticsSnapViewRecord.endTime - analyticsSnapViewRecord.startTime;
            }
            if (analyticsSnapViewRecord.fullView) {
                snapFullViewCount += 1;
                isSnapFullViewed = true;
            }
        }
        if (isSnapFullViewed) {
            snapUniqueViewCount += 1;
        }
    }
    logStoryViewWeb(exitEvent, 
    // TODO: EntryEvent should be one of TAP, SWIPE_UP or SWIPE_DOWN
    exitEvent === constants_1.ExitEvents.AUTO_ADVANCE ? StoryEntryEvent.REPLAY : StoryEntryEvent.TAP, snapUniqueViewCount, snapFullViewCount, (story.snaps || []).length, story.id || "", story.type.toString() || "", parseFloat((storyViewDuration / 1000).toFixed(1)) // time viewed in seconds upto 1st decimal
    );
}
exports.reportStoryStoryViewWeb = reportStoryStoryViewWeb;
//# sourceMappingURL=metrics.js.map